// extracted by mini-css-extract-plugin
module.exports = {"divLoading":"construction_divLoading__38MDX"};